import { useState, useEffect } from 'react';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import { format } from "date-fns";

import { Line, XAxis, YAxis, Tooltip, LineChart, ResponsiveContainer } from "recharts";

import { dateFormatTimestamp, dateFormat, dateFormatToday, dateFormatYesterday, inArray, getMonthYearTimestamp, getMonthYear } from "../utils/functions";

export default function Performance ({analytics}) {

	const [tooltip, setTooltip] = useState(false);
	const [linechart, setLinechart] = useState([]);
	const [ticks, setTicks] = useState([]);

	const types = ['Today', 'Yesterday', 'Week', 'Month', 'Quarter', 'Year'];
	const [activeType, setActiveType] = useState('Today');
	const selectType = (event) => {
		setActiveType(event.target.innerHTML);
	}

	useEffect(() => {
        graph();
    }, [analytics, activeType]);

    const graphHours = (date) => {

		setTooltip(false);

		let hours = [
			{ name: "00:00", Visitors: 0 },
			{ name: "04:00", Visitors: 0 },
			{ name: "08:00", Visitors: 0 },
			{ name: "12:00", Visitors: 0 },
			{ name: "16:00", Visitors: 0 },
			{ name: "20:00", Visitors: 0 },
			{ name: "00:00", Visitors: 0 },
		];

		let users = [];

		for (let key in analytics) {

			let item = analytics[key];
			if (item.timestamp.seconds) {

				if(date == dateFormatTimestamp(item.timestamp.seconds)) {

					if (!inArray(item.user_id, users)){

						users.push(item.user_id);

						var a = new Date(item.timestamp.seconds * 1000);
						var hour = a.getHours();

						if 		(hour >= 0 && hour < 4)		hours[0]['Visitors'] += 1;
						else if (hour >= 4 && hour < 8)		hours[1]['Visitors'] += 1;
						else if (hour >= 8 && hour < 12)	hours[2]['Visitors'] += 1;
						else if (hour >= 12 && hour < 16)	hours[3]['Visitors'] += 1;
						else if (hour >= 16 && hour < 20)	hours[4]['Visitors'] += 1;
						else if (hour >= 20 && hour < 24)	hours[5]['Visitors'] += 1;
					}
				}
			}

		}
		setLinechart(hours);
	}

	var today = new Date();
	today.setUTCHours(23,59,59,999);

	const graphDays = (date_from, date_to) => {

		setTooltip(false);

		let days = {};
		let users = [];

		for (var d = date_from; d <= date_to; d.setDate(d.getDate() + 1)) {

			let date = dateFormat(d);
			days[date] = 0;
		}

		for (let key in analytics) {

			let item = analytics[key];
			if (item.timestamp.seconds) {

				let date = dateFormatTimestamp(item.timestamp.seconds);

				if ( typeof(days[date]) !== 'undefined' && (typeof(users[date]) === 'undefined' || !inArray(item.user_id, users[date])) ){

					if (!users[date])
						users[date] = [];
					users[date].push(item.user_id);

					days[date]++;
				}
			}
		}

		var graph_data = [];

		var length = Object.keys(days).length;

		if (length > 7){;

			var shift = Math.ceil (length / 7);

			var tooltip = [];
			var last_date = false;
			var i = 0;
			for (let date in days){

				if(i%shift == 0){

					graph_data.push({
						name: date,
						Visitors: days[date],
					});

					last_date = date;


				} else {

					graph_data[graph_data.length-1]['Visitors'] += days[date];

				}

				if (!(tooltip[last_date]))
					tooltip[last_date] = [];
				tooltip[last_date].push(date);
				i++;
			}

			setTooltip(tooltip);


		} else {

			for (let date in days){
				graph_data.push({
					name: date,
					Visitors: days[date],
				});
			}
		}

		setLinechart(graph_data);

	}

	const graphMonths = (date_from, date_to) => {

		setTooltip(false);

		let months = [];
		let users = [];

		date_from.setMonth(date_from.getMonth() + 1);
		date_from.setDate(1);

		for (var d = date_from; d <= date_to; d.setDate(d.getDate() + 1)) {

			let month = getMonthYear(d);
			months[month] = 0;
		}

		for (let key in analytics) {

			let item = analytics[key];
			if (item.timestamp.seconds) {

				let date = dateFormatTimestamp(item.timestamp.seconds);
				let month = getMonthYearTimestamp(item.timestamp.seconds);

				if ( typeof(months[month]) !== 'undefined' && (typeof(users[month]) === 'undefined' || !inArray(item.user_id, users[date])) ){

					if (!users[date])
						users[date] = [];
					users[date].push(item.user_id);

					months[month]++;
				}
			}
		}

		var graph_data = [];
		for (let month in months){
			graph_data.push({
				name: month.replace(/\d/g, ''),
				Visitors: months[month],
			});
		}

		setLinechart(graph_data);

	}

	const graph = () => {

		switch(activeType) {

			//==========================
			case 'Today':

				graphHours(dateFormatToday());

				break;

			//==========================
			case 'Yesterday':

				graphHours(dateFormatYesterday());

				break;

			//==========================
			case 'Week':

				var date = new Date();
				date.setDate(date.getDate() - 6);
				graphDays(date, today);

				break;

			//==========================
			case 'Month':

				var date = new Date();
				date.setDate(date.getDate() - 30);
				graphDays(date, today);

				break;

			//==========================
			case 'Quarter':

				var date = new Date();
				date.setDate(date.getDate() - 120);
				graphDays(date, today);

				break;

			//==========================
			case 'Year':

				var date = new Date();
				date.setDate(date.getDate() - 365);
				graphMonths(date, today);

				break;
		}
	}


     //==================================


	const [isShowCalendar, ShowCalendar] = useState(false);
	const toggleCalendar = () => {
		ShowCalendar(!isShowCalendar);
	};
	const closeCalendar = () => {
		ShowCalendar(false);
	};


	const [date_range, setDate] = useState('');
    const calendarСhange = date => {

		setActiveType('calendar');
        setDate(format(date[0], "d MMM yyyy") + ' - ' + format(date[1], "d MMM yyyy"));
        closeCalendar();

		graphDays(date[0], date[1]);

    };

	const getLabel = (label) => {
		if (tooltip[label] && tooltip[label].length > 0)
		return tooltip[label][0] + ' - ' + tooltip[label][tooltip[label].length - 1];
	}

	const CustomTooltip = ({ active, payload, label }) => {
	if (active && payload && payload.length) {
		return (

			<div className="recharts-default-tooltip"><ul className="recharts-tooltip-item-list"><li className="recharts-tooltip-item"><span className="recharts-tooltip-item-value">

				{getLabel(label)}: {payload[0].value}

			</span><span className="recharts-tooltip-item-unit"></span></li></ul></div>

		);
	}

	return null;
	};

    return (

        <>
			<h2>App performance</h2>

			<div className="chart-control">
				<div className="tabs">
					{
						types.map((type, index) => (
							<div className={activeType == type ? "active" : ""} onClick={selectType} key={index}>{type}</div>
						))
					}
				</div>
				<div className={activeType == 'calendar' ? 'dates active' : 'dates'}>

					<div className={isShowCalendar ? 'date-range active' : 'date-range'}>
						<input onClick={toggleCalendar} value={date_range || "25 Jun 2022 - 30 Jun 2022"} readOnly />
					</div>

					<div onClick={closeCalendar} className={isShowCalendar ? 'calendar-wrapper' : 'calendar-wrapper hide'}></div>
					<div className="calendar">
						<Calendar locale="en-EN" className={isShowCalendar ? null : 'hide'} onChange={calendarСhange} returnValue="range" selectRange={true} />
					</div>

				</div>

			</div>
			<div className="subsection">
				<div className="title">Visitors</div>
				<div className="chart">

					<ResponsiveContainer width="95%" height={267}>

						<LineChart
							width={712}
							height={267}
							data={linechart}
							margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
						>
							<XAxis dataKey="name" />
							<YAxis type="number" allowDecimals={false}/>
							{
								tooltip ?
									<Tooltip content={<CustomTooltip />} />
									:
									<Tooltip />
							}
							<Line type="monotone" dataKey="Visitors" stroke="#B63FFF" yAxisId={0} />
						</LineChart>

					</ResponsiveContainer>

				</div>
			</div>
		</>
    )
}
